export const themeGlossary = {
    LIGHT: 'light',
    DARK: 'dark'
};
